// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  warId: __t.u64().primaryKey().name("war_id"),
  worldId: __t.u64().name("world_id"),
  aggressorSid: __t.u64().name("aggressor_sid"),
  defenderSid: __t.u64().name("defender_sid"),
  status: __t.string(),
  grievanceAtStart: __t.u32().name("grievance_at_start"),
  exhaustionA: __t.u32().name("exhaustion_a"),
  exhaustionB: __t.u32().name("exhaustion_b"),
  casualties: __t.u32(),
  lastClashAt: __t.timestamp().name("last_clash_at"),
  startedAt: __t.timestamp().name("started_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
